module.exports = __webpack_public_path__ + "img/resc_3kl.cd8b68a8.jpg";